import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SITE_ID_FETCH_SUCCESS } from "../../../Reducer/SiteIdSlice";
import ConfigurationNav from "./ConfigurationNav";
import DoorConfiguration from "./DoorConfiguration";
import RmsConfiguration from "./RmsConfiguration";
import "./SiteConfiguration.css";

export default function SiteConfiguration() {
    const { id: siteId } = useParams();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState("door");

    useEffect(() => {
        document.title = `iMac | Configuration (${siteId})`;
        dispatch(SITE_ID_FETCH_SUCCESS(siteId));
    }, [siteId, dispatch]);

    return (
        <div className="site-config-page px-2 pb-4">
            <ConfigurationNav
                activeTab={activeTab}
                onTabChange={setActiveTab}
                siteId={siteId}
            />

            <div className="config-layout__main">
                {activeTab === "door" ? (
                    <DoorConfiguration siteId={siteId} />
                ) : (
                    <RmsConfiguration siteId={siteId} />
                )}
            </div>
        </div>
    );
}
